// extracted by mini-css-extract-plugin
export var container = "_u-1";
export var copyright = "_u-3";
export var footer = "_u-0";
export var logo = "_u-2";